// import axios from 'axios';

// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// const api = axios.create({
//   baseURL: API_URL,
// });

// export default api; 


import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL, 
  
});

export default api;
